import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const EPMDashboardSkeleton = () => {
  const SKELETON_COLOR = '#e0e0e0';
  const SKELETON_COLOR_LIGHT = '#f5f5f5';

  return (
    <div className="epm-dashboard p-4 main_content_container">
      <Row className="mb-3">
        {[1, 2, 3, 4].map((index) => (
          <Col key={index} lg={3} className="mb-1">
            <Card className="device-coverage-card h-250">
              <Card.Body className="pt-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div
                      className="placeholder placeholder-wave"
                      style={{ width: '50px', height: '20px', backgroundColor: SKELETON_COLOR }}
                    ></div>
                  </div>
                  <div
                    className="placeholder placeholder-wave"
                    style={{
                      width: '46px',
                      height: '46px',
                      borderRadius: '12px',
                      backgroundColor: SKELETON_COLOR,
                      flexShrink: 0
                    }}
                  ></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="mb-1">
        <Col lg={6} className="mb-3">
          <Card className="h-100 top-list shadow-sm rounded-4 border">
            <Card.Header className="bg-white border-0 pb-0 pt-4">
              <div className="d-flex align-items-center">
                <div 
                  className="placeholder placeholder-wave rounded-circle me-2" 
                  style={{ width: '20px', height: '20px', backgroundColor: SKELETON_COLOR, flexShrink: 0 }}
                ></div>
                <div 
                  className="placeholder placeholder-wave" 
                  style={{ width: '200px', height: '20px', backgroundColor: SKELETON_COLOR }}
                ></div>
              </div>
            </Card.Header>
            <Card.Body className="pt-5">
              {[1, 2, 3, 4, 5].map((index) => (
                <div 
                  key={index} 
                  className="list-item p-3 mb-2 rounded-3 bg-white d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center flex-fill">
                    <div 
                      className="placeholder placeholder-wave me-3" 
                      style={{ 
                        width: '24px', 
                        height: '24px', 
                        borderRadius: '50%', 
                        backgroundColor: SKELETON_COLOR,
                        flexShrink: 0
                      }}
                    ></div>
                    <div className="flex-fill">
                      <div 
                        className="placeholder placeholder-wave mb-2" 
                        style={{ width: '60%', height: '16px', backgroundColor: SKELETON_COLOR }}
                      ></div>
                    </div>
                  </div>
                  <div 
                    className="placeholder placeholder-wave rounded-pill" 
                    style={{ width: '80px', height: '24px', backgroundColor: SKELETON_COLOR, flexShrink: 0 }}
                  ></div>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6} className="mb-3">
          <Card className="h-100 os-distribution border rounded-4 shadow-sm">
            <Card.Header className="bg-white border-0 pb-0 pt-4">
              <div 
                className="placeholder placeholder-wave" 
                style={{ width: '120px', height: '20px', backgroundColor: SKELETON_COLOR }}
              ></div>
            </Card.Header>
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div className="chart-container" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                <div 
                  className="placeholder placeholder-wave rounded-circle" 
                  style={{ 
                    width: '200px', 
                    height: '200px', 
                    margin: '0 auto', 
                    backgroundColor: SKELETON_COLOR_LIGHT 
                  }}
                ></div>
              </div>
              <div className="legend-container" style={{ flex: '0 0 50%', maxWidth: '50%', paddingLeft: '20px' }}>
                {[1, 2, 3].map((index) => (
                  <div key={index} className="legend-item d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                      <div 
                        className="placeholder placeholder-wave rounded-circle me-3" 
                        style={{ width: '12px', height: '12px', backgroundColor: SKELETON_COLOR, flexShrink: 0 }}
                      ></div>
                      <div 
                        className="placeholder placeholder-wave" 
                        style={{ width: '60px', height: '16px', backgroundColor: SKELETON_COLOR }}
                      ></div>
                    </div>
                    <div 
                      className="placeholder placeholder-wave" 
                      style={{ width: '50px', height: '14px', backgroundColor: SKELETON_COLOR }}
                    ></div>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EPMDashboardSkeleton;
